import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/agenda")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="events"
      label="Agenda"
      slugSource="title"
      fields={[
        { name: "title", label: "Título", type: "text", required: true },
        { name: "slug", label: "Slug", type: "slug" },
        { name: "description", label: "Descrição", type: "textarea" },
        { name: "event_date", label: "Data", type: "date", required: true },
        { name: "event_time", label: "Hora", type: "time" },
        { name: "address", label: "Endereço", type: "text" },
        { name: "neighborhood", label: "Bairro", type: "text" },
        { name: "city", label: "Cidade", type: "text" },
        { name: "map_url", label: "Link do mapa", type: "text" },
        { name: "image_url", label: "Imagem", type: "image" },
        { name: "featured", label: "Destaque", type: "boolean" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "event_status",
          label: "Situação",
          type: "select",
          options: [
            { label: "Agendado", value: "scheduled" },
            { label: "Cancelado", value: "cancelled" },
            { label: "Realizado", value: "done" },
          ],
        },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Título" },
        { key: "event_date", label: "Data" },
        { key: "event_status", label: "Situação" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
